import { DevelopedForItem } from './developed-for-template.component';

export const DEFAULT_DEVELOPED_FOR_TITLE = 'Desenvolvido para quem quer aproveitar oportunidades';

export const DEFAULT_DEVELOPED_FOR_DESCRIPTION =
  'A Casato Brasil organiza informações e disponibiliza ferramentas para que você acompanhe leilões com mais clareza e controle.';

export const DEFAULT_DEVELOPED_FOR_ITEMS: DevelopedForItem[] = [
  {
    title: 'Pesquise oportunidades em leilão',
    description:
      'Comece explorando os imóveis disponíveis. Use filtros, veja fotos, localização e encontre oportunidades alinhadas ao seu perfil e orçamento.',
    icon: 'search'
  },
  {
    title: 'Entenda os detalhes',
    description:
      'Tenha acesso a informações estruturadas sobre a situação do imóvel, possíveis pendências e dinâmica do leilão — de forma clara e objetiva.',
    icon: 'details'
  },
  {
    title: 'Simule os custos',
    description:
      'Visualize estimativas de aquisição, tributos e revenda para entender diferentes cenários antes de participar do leilão.',
    icon: 'simulate'
  },
  {
    title: 'Receba notificações',
    description:
      'Ative alertas para acompanhar imóveis específicos ou ser avisado quando surgirem oportunidades compatíveis com seus critérios.',
    icon: 'notifications'
  }
];
